'use es6';

import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useState } from 'react';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { NETWORK_OFFLINE, THREAD_HISTORY_FAILED, CREATE_NEW_THREAD_FAILED, SUBSCRIPTIONS_FAILED, PUBSUB_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED } from '../../constants/networkErrors';
import { jsx as _jsx } from "react/jsx-runtime";
const NetworkErrorAlerts = ({
  createNewThread,
  fetchOlderThreadHistory,
  networkError,
  startPubSub,
  resubscribe
}) => {
  const [dismissedNetworkErrors, setDismissedNetworkErrors] = useState([]);
  const dismissNetworkError = () => {
    setDismissedNetworkErrors([...dismissedNetworkErrors, networkError]);
  };
  if (dismissedNetworkErrors.includes(networkError)) {
    return null;
  }
  const title = (() => {
    switch (networkError) {
      case NETWORK_OFFLINE:
      case PUBSUB_FAILED:
      case SUBSCRIPTIONS_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        });
      case THREAD_HISTORY_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.pubSubFailure.title"
        });
      case CREATE_NEW_THREAD_FAILED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.newThreadFailure.title"
        });
      case CREATE_NEW_THREAD_FAILED_OUTDATED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.newThreadFailureOutdated.title"
        });
      default:
        return null;
    }
  })();
  const link = (() => {
    switch (networkError) {
      case THREAD_HISTORY_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onClick: fetchOlderThreadHistory,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case CREATE_NEW_THREAD_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onClick: createNewThread,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case SUBSCRIPTIONS_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onClick: resubscribe,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      case PUBSUB_FAILED:
        return /*#__PURE__*/_jsx(VizExLink, {
          use: "on-bright",
          onClick: startPubSub,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-ui.network.pubSubFailure.retry"
          })
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/_jsx(ChatAreaAlert, {
    title: title,
    onClose: dismissNetworkError,
    link: link
  });
};
NetworkErrorAlerts.displayName = 'NetworkErrorAlerts';
NetworkErrorAlerts.propTypes = {
  createNewThread: PropTypes.func.isRequired,
  fetchOlderThreadHistory: PropTypes.func.isRequired,
  networkError: PropTypes.oneOf([NETWORK_OFFLINE, THREAD_HISTORY_FAILED, CREATE_NEW_THREAD_FAILED, CREATE_NEW_THREAD_FAILED_OUTDATED, PUBSUB_FAILED, SUBSCRIPTIONS_FAILED]).isRequired,
  resubscribe: PropTypes.func.isRequired,
  startPubSub: PropTypes.func.isRequired
};
export default NetworkErrorAlerts;